import store from "@/store"

import find from "lodash/find"
import lang from "@/lang";
import auth from "@/auth";

export default {
  path: '/organisation/:organisationId',
  components: {
    default: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
    menu: () => import(/* webpackChunkName: "organisation" */ './menu.vue'),
  },
  meta: {
    section: 'organisation'
  },
  beforeEnter: function (to, from, next) {
    if (! auth.checkAccess('organisation', ['admin', 'organiser'])) {
      return next(store.state.user.homepage)
    }

    // TODO load all organisation data?
    let tasks = [
      store.dispatch("organisations.getById", to.params.organisationId),
      store.dispatch("events.get", to.params.organisationId),
      store.dispatch('disciplines.get'),
    ]

    Promise.all(tasks).then(() => {
      const organisation = store.state.organisations.items.find(o => o.id === to.params.organisationId)
      if (organisation.language) {
        lang.setLocale(organisation.language)
      }
      store.dispatch("environment.setTitle", organisation.name)
      next()
    })
  },
  children: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
      children: [
        {
          path: '/',
          name: 'organisation.events',
          component: () => import(/* webpackChunkName: "organisation" */ './events.vue'),
        },
        {
          path: 'add-event',
          name: 'organisation.events.add',
          component: () => import(/* webpackChunkName: "organisation" */ './addEvent.vue'),
        }
      ]
    },
    {
      path: 'settings',
      name: 'organisation.settings',
      component: () => import(/* webpackChunkName: "organisation" */ './organisation.vue'),
    },
    {
      path: 'users',
      component: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
      beforeEnter: function (to, from, next) {
        store.dispatch('organisationUsers.get', to.params.organisationId).then(() => {
          next()
        })
      },
      children: [
        {
          path: '/',
          name: 'organisation.users',
          component: () => import(/* webpackChunkName: "organisation" */ './users/userList.vue'),
        },
        {
          path: 'add',
          name: 'organisation.users.add',
          component: () => import(/* webpackChunkName: "organisation" */ './users/addUser.vue'),
        },
      ]
    },
    {
      path: 'passwords',
      name: 'organisation.passwords',
      component: () => import(/* webpackChunkName: "organisation" */ './organisationPasswords.vue'),
    },
    {
      path: 'planningDefaults',
      component: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
      beforeEnter: function (to, from, next) {
        store.dispatch("planningDefaults.load", {
          organisationId: to.params.organisationId,
        }).then(() => {
          next()
        })
      },
      children: [
        {
          path: '/',
          name: 'organisation.planningDefaults',
          component: () => import(/* webpackChunkName: "organisation" */ './planning/list.vue'),
        }, {
          path: ':planningDefaultId',
          component: () => import(/* webpackChunkName: "organisation" */ './planning/planningWrapper.vue'),
          children: [{
            path: '/',
            name: 'organisation.planningDefault.view',
            component: () => import(/* webpackChunkName: "organisation" */ './planning/viewConfig.vue'),
          }, {
            path: 'templates',
            component: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
            beforeEnter: function (to, from, next) {
              const planningDefault = find(store.state.planningDefaults.items, i => i.id === to.params.planningDefaultId);
              store.dispatch("importTemplates.load", {
                organisationId: to.params.organisationId, disciplineId: planningDefault.disciplineId,
              }).then(() => {
                next()
              })
            },
            children: [{
              path: '/',
              name: 'organisation.planning.templates',
              component: () => import(/* webpackChunkName: "organisation" */ './planning/templateList.vue'),
            }, {
              path: ':templateId',
              name: 'organisation.planning.template.edit',
              component: () => import(/* webpackChunkName: "organisation" */ './planning/templateView.vue'),
            }, {
              path: 'add',
              name: 'organisation.planning.template.add',
              component: () => import(/* webpackChunkName: "organisation" */ './planning/templateAdd.vue'),
            }]
          }]
        }, {
          path: 'add',
          name: 'organisation.planningDefault.add',
          component: () => import(/* webpackChunkName: "organisation" */ './planning/addConfig.vue'),
        }
      ]
    },
    {
      path: 'displayTemplates',
      component: () => import(/* webpackChunkName: "organisation" */ '@/components/wrapper.vue'),
      beforeEnter: function (to, from, next) {
        store.dispatch("displayTemplates.load", {
          organisationId: to.params.organisationId,
        }).then(() => {
          next()
        })
      },
      children: [
        {
          path: '/',
          name: 'organisation.displayTemplates',
          component: () => import(/* webpackChunkName: "organisation" */ './displayTemplates/list.vue'),
        },
        {
          path: ':templateId',
          name: 'organisation.displayTemplate.view',
          component: () => import(/* webpackChunkName: "organisation" */ './displayTemplates/viewSet.vue'),
        },
        {
          path: 'add',
          name: 'organisation.displayTemplate.add',
          component: () => import(/* webpackChunkName: "organisation" */ './displayTemplates/addSet.vue'),
        }
      ]
    },
  ]
}

